exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.error-modal button.btn.close.close-modal[data-v-b5f5b1c8]{top:-70px;position:relative}div.error-modal legend.close-modal[data-v-b5f5b1c8]{max-height:55px}", ""]);

// exports
